/**
 * 获取用户数据的公共方法
 * @param {string} customerEmail - 用户邮箱
 * @param {string} earnWaysListSelector - 积分规则列表的 DOM 选择器，默认为 '.earn-ways-list'
 * @param {boolean|function} isFirstLogin - 是否第一次登录，用于决定是否给予首次登录奖励。可以是布尔值或返回布尔值的函数
 * @param {Object} options - 可选配置对象
 * @param {Object} options.sswclient - 可选的 SSWClient 实例。如果不提供，将使用默认配置创建新实例
 * @param {string} options.appId - SSWClient 的 appId，默认为 '18280412c6c87077d4f1c42df612d688'
 * @param {string} options.appSecret - SSWClient 的 appSecret，默认为 '56b6079304224defa691c419ac166ebd'
 * @returns {Promise<Object>} 返回包含用户数据的对象 { userData, earnRules, userLink }
 *
 * @example
 * // 使用默认配置
 * getUserData('user@example.com').then(result => { ... });
 *
 * // 传入已存在的 SSWClient 实例
 * const sswclient = new SSWClient('appId', 'appSecret');
 * getUserData('user@example.com', '.earn-ways-list', false, { sswclient }).then(result => { ... });
 *
 * // 使用自定义配置
 * getUserData('user@example.com', '.earn-ways-list', false, {
 *   appId: 'custom-app-id',
 *   appSecret: 'custom-app-secret'
 * }).then(result => { ... });
 */
async function getUserData(
  customerEmail,
  options = {}
) {
  // 检查 SSWClient 是否已加载
  if (typeof SSWClient === 'undefined') {
    return Promise.reject(
      new Error(
        'SSWClient is not loaded. Please ensure ssw-client.js is loaded before calling getUserData.'
      )
    );
  }

  // 如果没有传入 sswclient 实例，则创建新实例
  let sswclient = options.sswclient;
  if (!sswclient) {
    const defaultConfig = {
      appId: '18280412c6c87077d4f1c42df612d688',
      appSecret: '56b6079304224defa691c419ac166ebd',
    };
    const appId = options.appId || defaultConfig.appId;
    const appSecret = options.appSecret || defaultConfig.appSecret;
    sswclient = new SSWClient(appId, appSecret);
  }
  console.log(sswclient, 'sswclient=================>');

  return new Promise((resolve, reject) => {
    sswclient.getAppToken(
      'read_user write_user read_wishlist write_wishlist read_review write_review read_gallery read_reward write_reward app_install',
      async (res) => {
        if (!res) {
          reject(new Error('Failed to get app token'));
          return;
        }

        try {
          // 根据邮箱搜索当前用户
          const userData = await new Promise((resolveUser, rejectUser) => {
            sswclient.searchUser(customerEmail, ({ status, data }) => {
              if (status === 200 && data) {
                resolveUser(data);
              } else {
                rejectUser(new Error('Failed to search user'));
              }
            });
          });

          const userLink = userData.refer_link;
          console.log(userData, 'gamesUserData=================>');

          // 获取积分规则
          const earnRules = await new Promise((resolveRules, rejectRules) => {
            sswclient.getEarningRules(userData.user_id, 'all', ({ status, data }) => {
              if (status === 200 && data) {
                resolveRules(data);
              } else {
                rejectRules(new Error('Failed to get earning rules'));
              }
            });
          });

          console.log(earnRules, '=============>赚取规则');

          resolve({
            userData,
            earnRules,
            userLink,
          });
        } catch (error) {
          reject(error);
        }
      }
    );
  });
}
